import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-testid": "strategy-profile-creation-details-headline-block" }
const _hoisted_2 = { class: "custom-font-text" }
const _hoisted_3 = { class: "error-feedback-block" }

import {ref, onMounted, computed, inject} from 'vue';
    import {useStore} from 'vuex';
    import {TipsPart} from '@/profile-creation-wizard/components/for-creation/TipsPart';
    import {DI} from '@/profile-creation-wizard/common/DependencyInjection';
    import {CreationFormValidation} from '@/profile-creation-wizard/components/for-creation/ProfileCreationForm';
    import getters from '@/profile-creation-wizard/store/creation/getters';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';
    import {ProfileCreationForm} from '@/profile-creation-wizard/types';
    import CharacterCount from './CharacterCount.vue';
    import {useTranslation} from '@malt/vue3-use';

    const bottomSheetSelector = '#headline-details-bottom-sheet';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'StrategyHeadlineSelection',
  props: {
    title: {},
    subtitle: {},
    subtitleHelp: {}
  },
  emits: ["headline-keypress-enter"],
  setup(__props: any, { emit: __emit }) {

    const {msg} = useTranslation();

    const store = useStore();
    const creationForm = ref<ProfileCreationForm>(store.getters[getters.creationForm]);

    const creationFormValidation = inject<CreationFormValidation>(DI.creationFormValidation);
    const MAX_CHAR_LIMIT = creationFormValidation?.headlineValidationRules.maxCharLimit;
    const MIN_CHAR_LIMIT = creationFormValidation?.headlineValidationRules.minCharLimit;

    const error = ref<boolean>(false);
    const refStrategyProfileHeadline = ref<HTMLElement>();
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    onMounted(async () => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer(bottomSheetSelector, refStrategyProfileHeadline.value, 'div.profile-creation-wizard');
    });

    const emit = __emit;

    const props = __props;

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

    function emitFocus(): void {
        eventBusProfileCreationWizard.emit('creation:focus-changed', TipsPart.title);
    }

    function validate(): void {
        if (creationForm.value.headline.trim().length === 0) {
            error.value = true;
            return;
        }

        error.value = !creationFormValidation?.isHeadlineValid(creationForm.value.headline);
    }

    const hasError = computed(() => error.value);

    function headlineKeypressEnter(): void {
        updateHeadline();

        if (!error.value) {
            emit('headline-keypress-enter');
        }
    }

    function updateHeadline(): void {
        validate();
        store.commit(mutations.clearFamiliesAndCategories);
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyInput = _resolveComponent("VJoyInput")!
  const _component_VJoyFormError = _resolveComponent("VJoyFormError")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "refStrategyProfileHeadline",
    ref: refStrategyProfileHeadline
  }, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(props.title), 1),
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(props.subtitle) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        onClick: openBottomSheet
      }, _toDisplayString(props.subtitleHelp), 1)
    ]),
    _createVNode(_component_VJoyInput, {
      id: "strategy-profile-headline",
      modelValue: creationForm.value.headline,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((creationForm.value.headline) = $event)),
        updateHeadline
      ],
      name: "strategy-profile-headline",
      "data-testid": "strategy-profile-headline-input",
      placeholder: _unref(msg)('profile.creation.wizard.strategy.headline.placeholder'),
      invalid: hasError.value,
      onFocus: emitFocus,
      onKeypress: _withKeys(headlineKeypressEnter, ["enter"])
    }, null, 8, ["modelValue", "placeholder", "invalid"]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(_component_VJoyFormError, {
        class: "error",
        "no-html-error-text": _unref(msg)('profile.creation.wizard.strategy.headline.error', _unref(MIN_CHAR_LIMIT), _unref(MAX_CHAR_LIMIT))
      }, null, 8, ["no-html-error-text"]), [
        [_vShow, hasError.value]
      ]),
      _createVNode(CharacterCount, {
        class: "counter",
        "is-invalid-count": hasError.value,
        max: _unref(MAX_CHAR_LIMIT),
        count: creationForm.value.headline?.trim().length
      }, null, 8, ["is-invalid-count", "max", "count"])
    ])
  ], 512))
}
}

})